module.exports = __webpack_public_path__ + "img/iconLiShiWuRenGuoBang.dcc1c11c.svg";